<template>
  <div class="write-about-us">
    <h2 class="write-about-us-title">{{ result.messages.title }}</h2>
    <div>
      <DefSlider :settings="settings" :nav="false" :pagination="false" :priority="true">
        <a v-for="(item, i) in items" :key="item.id" :href="item.link" class="swiper-slide">
          <DefImg :result="item.picture" :priority="i < slidesCount" />
        </a>
      </DefSlider>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
// import { Autoplay } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';
import { Breakpoints } from '@/settings/device';
import useScreenWidth from '@use/useScreenWidth';

interface IResult {
  messages: { title: string };
  items: [
    {
      id: number;
      name: string;
      detailPage: string;
      article: number;
      picture: {
        src: string;
        alt: string;
        width: number;
        height: number;
        isPicturePlug: boolean;
      };
      link: string;
    }
  ];
}

const screenWidth = useScreenWidth();

const props = defineProps<{ result: IResult }>();

const items = computed(() => props.result?.items);

const slidesCount = computed<number>(() => {
  if (screenWidth.value >= Breakpoints.desktop) {
    return 5;
  }
  if (screenWidth.value >= Breakpoints.tablet) {
    return 4;
  }
  return 3;
});

const settings: SwiperOptions = {
  slidesPerView: 2.7,
  spaceBetween: 20,
  // modules: [Autoplay],
  // autoplay: {
  //   delay: 5000,
  // },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 60,
    },
    992: {
      slidesPerView: 5,
      spaceBetween: 80,
    },
  },
  // loop: true,
};
</script>
<style scoped lang="scss">
.write-about-us {
  background-color: var(--background-beige);
  padding: 20px 16px;
  @include point-md {
    padding: 20px 24px;
  }
  @include point-lg {
    display: grid;
    align-items: center;
    grid-template-columns: 200px minmax(0, 1fr);
    grid-column-gap: 32px;
    padding: 32px;
  }
  :deep(.def-slider__container) {
    margin-bottom: 0;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
  }
}
.write-about-us-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 125%;
  text-transform: uppercase;
  margin-bottom: 16px;
  text-align: center;
  @include point-md {
    font-size: 18px;
    margin-bottom: 20px;
  }
  @include point-lg {
    margin-bottom: 0;
    text-align: start;
  }
}
</style>
